// @core/api/endpoints/chat/delete_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Delete conversation
 * Permanently deletes a conversation and all its messages. This action is irreversible and requires owner privileges on the conversation.
 */
export async function DeleteConversation(
  conversation_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
